import { calcStatePosition, calcTemporaryState } from './calcs';

export const SET_STATE_WIDGETS = 'SET_STATE_WIDGETS';
export const SET_SPACING = 'SET_SPACING';
export const SET_BOARD_WIDTH = 'SET_BOARD_WIDTH';
export const SET_WIDGETS_SIZES = 'SET_WIDGETS_SIZES';
export const SET_DRAG_INFO = 'SET_DRAG_INFO';

export const reducer = (state, action) => {
  switch (action.type) {
    case SET_STATE_WIDGETS: {
      const { stateWidgets } = action.payload;
      const { widgetPositions, rowPositions } = calcStatePosition({
        stateWidgets,
        spacing: state.spacing,
        boardWidth: state.boardWidth,
        widgetSizes: state.widgetSizes,
      });

      return {
        ...state,
        stateWidgets,
        widgetPositions,
        rowPositions,
      };
    }

    case SET_SPACING: {
      const { spacing } = action.payload;
      const { rowPositions, widgetPositions } = calcStatePosition({
        stateWidgets: state.stateWidgets,
        spacing,
        boardWidth: state.boardWidth,
        widgetSizes: state.widgetSizes,
      });

      return {
        ...state,
        spacing,
        widgetPositions,
        rowPositions,
      };
    }

    case SET_BOARD_WIDTH: {
      const { boardWidth } = action.payload;
      const { rowPositions, widgetPositions } = calcStatePosition({
        stateWidgets: state.stateWidgets,
        spacing: state.spacing,
        boardWidth,
        widgetSizes: state.widgetSizes,
      });

      return {
        ...state,
        boardWidth,
        widgetPositions,
        rowPositions,
      };
    }

    case SET_WIDGETS_SIZES: {
      const { widgetSizes } = action.payload;
      const { rowPositions, widgetPositions } = calcStatePosition({
        stateWidgets: state.stateWidgets,
        spacing: state.spacing,
        boardWidth: state.boardWidth,
        widgetSizes,
      });

      return {
        ...state,
        widgetSizes,
        widgetPositions,
        rowPositions,
      };
    }

    case SET_DRAG_INFO: {
      const { dragInfo } = action.payload;

      if (!dragInfo) {
        if (!state.dragInfo) {
          return state;
        }

        return {
          ...state,
          dragInfo: null,
          stateWidgets: state.temporaryStateWidgets,
          widgetPositions: state.temporaryWidgetPositions,
          rowPositions: state.temporaryRowPositions,
          temporaryStateWidgets: null,
          temporaryWidgetPositions: null,
          temporaryRowPositions: null,
        };
      }

      const temporaryStateWidgets = calcTemporaryState({
        stateWidgets: state.temporaryStateWidgets || state.stateWidgets,
        widgetPositions: state.widgetPositions,
        rowPositions: state.temporaryRowPositions || state.rowPositions,
        boardWidth: state.boardWidth,
        dragInfo,
      });

      const {
        rowPositions: temporaryRowPositions,
        widgetPositions: temporaryWidgetPositions,
      } = calcStatePosition({
        stateWidgets: temporaryStateWidgets,
        spacing: state.spacing,
        boardWidth: state.boardWidth,
        widgetSizes: state.widgetSizes,
      });

      return {
        ...state,
        dragInfo,
        temporaryWidgetPositions,
        temporaryRowPositions,
        temporaryStateWidgets,
      };
    }

    default:
      return state;
  }
};

export default reducer;
